export interface IAnnualReportTemplateNotesTypesTableData {
    _id?: string;
    name: string;
    selected?: boolean;
}
